import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {PhoneIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {AmplitudeButtonCategory, AmplitudeOfferContactButtonName, trackAmplitudeButtonClick} from "../tracking/amplitude/track_amplitude_button_click";
import {hotlineTelNumber} from "../types/HotlineTelNumber";
import {ClipPhoneButton} from "./ClipPhoneButton";

interface IProps {
    offerId: number | null;
    propertyId?: number | null;
    buttonVariant?: "filled_primary" | "outlined_secondary";
    buttonSize?: IButtonSizePrimary;
    buttonClassName?: string;
    className?: string;
    // overrides the page category derived from propertyId, e.g. for the listing views
    buttonCategory?: AmplitudeButtonCategory;
    // shows the number right away instead of the "Pokaż numer" button
    fetchOnMount?: boolean;
    // "link" renders the revealed number as an icon with the number text instead of a button
    phoneDisplay?: "button" | "link";
    customButtonText?: string;
}

// Replaces the lead CTAs of a compass offer - its vendor takes no leads, so the button reveals our hotline number instead
export const HotlinePhoneButton = (props: IProps) => {
    const {
        offerId,
        propertyId,
        buttonVariant = "outlined_secondary",
        buttonSize,
        buttonClassName,
        className,
        buttonCategory,
        fetchOnMount,
        phoneDisplay = "button",
        customButtonText
    } = props;

    const trackClick = (buttonName: AmplitudeOfferContactButtonName, buttonLink?: string) => {
        if (!offerId) {
            return;
        }

        trackAmplitudeButtonClick({
            buttonName,
            buttonCategory: buttonCategory ?? (propertyId ? "property_page" : "investment_page"),
            itemId: offerId,
            propertyId,
            buttonLink,
            additionalEventProperties: {is_compass_offer: 1}
        });
    };

    return (
        <ClipPhoneButton
            fallbackNumber={hotlineTelNumber}
            propertyId={propertyId ?? undefined}
            fetchOnMount={fetchOnMount}
            buttonVariant={buttonVariant}
            buttonSize={buttonSize}
            buttonStyleOverride={buttonClassName}
            className={className}
            onShowPhoneNumber={() => trackClick("offer_show_number")}
            onClickPhoneNumber={(phoneNumber) => trackClick("offer_call_investor", phoneNumber)}
            customPhoneButton={(onClick, phoneNumber) => {
                const href = `tel:+${phoneNumber.replace(/ /g, "")}`;

                if (phoneDisplay === "link") {
                    return (
                        <Button
                            variant="none_secondary"
                            href={href}
                            onClick={onClick}
                            iconLeft={PhoneIcon}
                            iconLeftProps={{wrapperColor: "var(--colors-primary)", wrapperSize: "4", size: "2.4"}}
                        >
                            <Text variant="body_copy_1">{customButtonText ?? phoneNumberFormat(phoneNumber)}</Text>
                        </Button>
                    );
                }

                return (
                    <Button variant={buttonVariant} size={buttonSize} iconLeft={PhoneIcon} href={href} onClick={onClick} className={buttonClassName}>
                        {customButtonText ?? phoneNumberFormat(phoneNumber)}
                    </Button>
                );
            }}
        />
    );
};
import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {PhoneIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {AmplitudeButtonCategory, AmplitudeOfferContactButtonName, trackAmplitudeButtonClick} from "../tracking/amplitude/track_amplitude_button_click";
import {hotlineTelNumber} from "../types/HotlineTelNumber";
import {ClipPhoneButton} from "./ClipPhoneButton";

interface IProps {
    offerId: number | null;
    propertyId?: number | null;
    buttonVariant?: "filled_primary" | "outlined_secondary";
    buttonSize?: IButtonSizePrimary;
    buttonClassName?: string;
    className?: string;
    // overrides the page category derived from propertyId, e.g. for the listing views
    buttonCategory?: AmplitudeButtonCategory;
    // shows the number right away instead of the "Pokaż numer" button
    fetchOnMount?: boolean;
    // "link" renders the revealed number as an icon with the number text instead of a button
    phoneDisplay?: "button" | "link";
    customButtonText?: string;
}

// Replaces the lead CTAs of a compass offer - its vendor takes no leads, so the button reveals our hotline number instead
export const HotlinePhoneButton = (props: IProps) => {
    const {
        offerId,
        propertyId,
        buttonVariant = "outlined_secondary",
        buttonSize,
        buttonClassName,
        className,
        buttonCategory,
        fetchOnMount,
        phoneDisplay = "button",
        customButtonText
    } = props;

    const trackClick = (buttonName: AmplitudeOfferContactButtonName, buttonLink?: string) => {
        if (!offerId) {
            return;
        }

        trackAmplitudeButtonClick({
            buttonName,
            buttonCategory: buttonCategory ?? (propertyId ? "property_page" : "investment_page"),
            itemId: offerId,
            propertyId,
            buttonLink,
            additionalEventProperties: {is_compass_offer: 1}
        });
    };

    return (
        <ClipPhoneButton
            fallbackNumber={hotlineTelNumber}
            propertyId={propertyId ?? undefined}
            fetchOnMount={fetchOnMount}
            buttonVariant={buttonVariant}
            buttonSize={buttonSize}
            buttonStyleOverride={buttonClassName}
            className={className}
            onShowPhoneNumber={() => trackClick("offer_show_number")}
            onClickPhoneNumber={(phoneNumber) => trackClick("offer_call_investor", phoneNumber)}
            customPhoneButton={(onClick, phoneNumber) => {
                const href = `tel:+${phoneNumber.replace(/ /g, "")}`;

                if (phoneDisplay === "link") {
                    return (
                        <Button
                            variant="none_secondary"
                            href={href}
                            onClick={onClick}
                            iconLeft={PhoneIcon}
                            iconLeftProps={{wrapperColor: "var(--colors-primary)", wrapperSize: "4", size: "2.4"}}
                        >
                            <Text variant="body_copy_1">{customButtonText ?? phoneNumberFormat(phoneNumber)}</Text>
                        </Button>
                    );
                }

                return (
                    <Button variant={buttonVariant} size={buttonSize} iconLeft={PhoneIcon} href={href} onClick={onClick} className={buttonClassName}>
                        {customButtonText ?? phoneNumberFormat(phoneNumber)}
                    </Button>
                );
            }}
        />
    );
};
